import { useIntl } from 'react-intl';
import { Row, Col } from 'reactstrap';
import Drawer from 'src/componentes/drawer';
import LucideIcon from 'src/componentes/lucide-icon';
import ViewHistorico from './view';

const Historico = ({
  openHistorical,
  setOpenHistorical,
  projetoId,
  etapaStageGateId,
  nomeProjeto,
}) => {
  const intl = useIntl();

  const handleClose = () => setOpenHistorical(false);

  return (
    <Drawer
      title={
        <div className="d-flex align-items-center">
          <LucideIcon
            icon="chevron-right"
            onClick={handleClose}
            style={{ marginRight: '10px' }}
          />
          {intl.formatMessage({ id: 'historico' })}
        </div>
      }
      open={openHistorical}
      close={handleClose}
    >
      <Row>
        <Col md={12}>
          <div
            className="text-primary mb-2 text-wrap font-weight-bold"
            style={{ textAlign: 'left' }}
          >
            {nomeProjeto}
          </div>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <ViewHistorico
            projetoId={projetoId}
            etapaStageGateId={etapaStageGateId}
          />
        </Col>
      </Row>
    </Drawer>
  );
};

export default Historico;
